export default "__VITE_ASSET__DEEQNDWf__"